<template>
    <div class="sidebar">
        <div class="logo">
            <img src="/static/img/proebitda_logo_color.png" />
        </div>
        <div class="menu-items">
            
            <router-link tag="div" class="menu-item" :to="{name: 'Index'}">
                <div class="icon">
                    <i class="fad fa-fw fa-th-large" />
                </div>
                <div class="name">
                    Overblik
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'EconomyLearning'}" :class="{'router-link-exact-active': subIsActive('/oekonomi')}" v-if="$auth.user().roles[0].name !== 'department-responsible'">
                <div class="icon">
                    <i class="fad fa-fw fa-wallet" />
                </div>
                <div class="name">
                    Økonomi
                </div>
            </router-link>
            
            <router-link tag="div" class="menu-item" :to="{name: 'ProjectsLearning'}" :class="{'router-link-exact-active': subIsActive('/opgaver')}">
                <div class="icon">
                    <i class="fad fa-fw fa-clipboard-list-check" />
                </div>
                <div class="name">
                    Opgaver
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'CustomersLearning'}" :class="{'router-link-exact-active': subIsActive('/kunder')}">
                <div class="icon">
                    <i class="fad fa-fw fa-briefcase" />
                </div>
                <div class="name">
                    Kunder
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'EmployeesLearning'}" :class="{'router-link-exact-active': subIsActive('/medarbejdere')}">
                <div class="icon">
                    <i class="fad fa-fw fa-users" />
                </div>
                <div class="name">
                    Medarbejdere
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'Responsibles'}" :class="{'router-link-exact-active': subIsActive('/ansvarlige')}">
                <div class="icon">
                    <i class="fad fa-fw fa-user-hard-hat" />
                </div>
                <div class="name">
                    Ansvarlige
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'Potential'}" :class="{'router-link-exact-active': subIsActive('/potentiale')}" v-if="$auth.user().roles[0].name !== 'department-responsible'">
                <div class="icon">
                    <i class="fas fa-fw fa-star" />
                </div>
                <div class="name">
                    Potentiale
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'Settings'}" v-if="$auth.user().roles[0].name !== 'user' && $auth.user().roles[0].name !== 'department-responsible'">
                <div class="icon">
                    <i class="fad fa-fw fa-cog" />
                </div>
                <div class="name">
                    Indstillinger
                </div>
            </router-link>

            <router-link tag="div" class="menu-item" :to="{name: 'Enterprise'}" v-if="$auth.user().roles[0].name === 'super-admin'">
                <div class="icon">
                    <i class="fad fa-fw fa-tools" />
                </div>
                <div class="name">
                    Entreprise
                </div>
            </router-link>

            <!--<router-link tag="div" class="menu-item" :to="{name: 'SuperAdmin'}">
                <div class="icon">
                    <i class="fad fa-fw fa-user-cog" />
                </div>
                <div class="name">
                    Super Admin
                </div>
            </router-link>-->

            <!--<div class="menu-item" v-for="item in routes" v-bind:key="item.route" @click="goToRoute(item)" :class="{'router-link-exact-active': $route.name === item.route}">
                <div class="icon">
                    <i :class="'fad fa-fw fa-' + item.icon" />
                </div>
                <div class="name">
                    {{ item.name }}
                </div>
            </div>-->
        </div>
        <div class="bottom">
            <div class="last-sync" v-if="lastSync">
                Data opdateret:
                <br>
                {{ lastSync }}
            </div>
            <div class="user" @click="logout">
                <div class="avatar">
                    {{ initials }}
                </div>
                <div class="text">
                    <div class="name">
                        {{ $auth.user().name }}
                    </div>
                    <div class="company" v-if="$store.state.config.companyMeta">
                        {{ $store.state.config.companyMeta.name }}
                    </div>
                </div>
            </div>
            <router-link tag="div" :to="{name: 'ChangeCompany'}" class="super-admin-options" v-if="$auth.user().roles[0].name === 'super-admin'">
                <div class="change-company">
                    <i class="fas fa-building fa-fw" />
                    Skift virksomhed
                </div>
            </router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .sidebar {
        padding: $padding--main;
        height: 100vh;
        overflow-y: auto;
        background: $color--dark;
        color: $color--white;
        position: relative;
        z-index: 100;

        .logo {
            margin: 0 -$padding--main;
            padding: 0 $padding--main;
            margin-bottom: $margin--large;
            height: 80px;
            display: flex;
            align-items: center;
            // border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            text-align: center;
            background: $color--white;

            img {
                width: 80%;
                margin: 0 auto;
            }
        }

        .menu-items {

            .menu-item {
                display: flex;
                align-items: center;
                color: $color--white;
                text-decoration: none;
                font-weight: $fontweight--light;
                padding: ($padding--small / 2);
                border-radius: $borderradius--main;
                font-family: $fontfamily--main;
                font-size: $fontsize--main;
                cursor: pointer;
                transition: $transition--main;

                &.disabled {
                    opacity: .5;
                    cursor: not-allowed;
                }

                &:hover {
                    background: rgba(255, 255, 255, .15);
                    padding-left: $padding--small;
                }

                &:not(:last-of-type) {
                    margin-bottom: ($margin--small / 2);
                }

                &.router-link-exact-active {
                    background: $color--white;
                    color: $color--dark;
                    font-weight: $fontweight--main;
                    padding-left: $padding--small;
                }

                .icon {
                    margin-right: $margin--small;
                    font-size: $fontsize--medium;
                }

                .name {

                }
            }
        }

        .bottom {
            position: absolute;
            bottom: $padding--small;
            left: $padding--small;
            width: calc(100% - #{$padding--main});

            .super-admin-options {
                padding-top: $padding--small;

                .change-company {
                    background: $color--white;
                    box-sizing: border-box;
                    border-radius: $borderradius--main;
                    padding: 4px 10px;
                    color: $color--dark;
                    text-align: center;
                    font-size: $fontsize--sm;
                    cursor: pointer;

                    &:hover {
                        background: rgba(255, 255, 255, 0.9);
                    }
                }
            }

            .last-sync {
                font-size: $fontsize--small;
                text-align: center;
                padding-bottom: $padding--small / 2;
            }
        }

        .user {
            display: flex;
            align-items: center;
            font-family: $fontfamily--main;
            cursor: pointer;
            padding: $padding--small / 2;
            border-radius: $borderradius--main;
            line-height: 1.4;

            &:hover {
                background: rgba(255, 255, 255, .15);
            }

            .avatar {
                margin-right: $margin--small;
                border-radius: $borderradius--full;
                background: $color--white;
                height: 40px;
                width: 40px;
                line-height: 40px;
                text-align: center;
                font-weight: $fontweight--bold;
                letter-spacing: 1px;
                color: $color--dark;
            }

            .text {
                width: calc(100% - #{$margin--main * 2});

                .name {
                    font-weight: $fontweight--main;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                .company {
                    // font-weight: $fontweight--light;
                    font-size: $fontsize--small;
                }
            }
        }
    }

</style>

<script>
import moment from 'moment'

export default {
    data () {
        return {
            routes: [
                {
                    name: 'Startside',
                    icon: 'home',
                    route: 'Index',
                    onlySuperAdmin: false
                },
                {
                    name: 'Økonomi',
                    icon: 'wallet',
                    route: 'Economy',
                    onlySuperAdmin: true
                },
                {
                    name: 'Kunder',
                    icon: 'briefcase',
                    route: 'Customers',
                    onlySuperAdmin: true
                },
                {
                    name: 'Opgaver',
                    icon: 'clipboard-list-check',
                    route: 'ProjectsOperations',
                    onlySuperAdmin: false
                },
                {
                    name: 'Medarbejdere',
                    icon: 'users',
                    route: 'Employees',
                    onlySuperAdmin: true
                },
                {
                    name: 'Indstillinger',
                    icon: 'cog',
                    route: 'Settings',
                    onlySuperAdmin: true
                },
                {
                    name: 'Super Admin',
                    icon: 'user-cog',
                    route: 'SuperAdmin',
                    onlySuperAdmin: true
                }
            ]
        }
    },
    computed: {
        initials () {
            if (this.$auth.user().name) {
                let initials = this.$auth.user().name.split(' ').map((n) => n[0]).join('')
                let splittedString = initials.match(/.{1,2}/g)
                return splittedString[0]
            }
        },
        lastSync () {
            if (this.$store.state.config && this.$store.state.config.lastSynced) {
                let date = this.$store.state.config.lastSynced
                let formatted = moment(date).format('D. MMMM YYYY [kl.] HH:mm')
                /* let formatted = moment(date).calendar(null, {
                    sameDay: '[I dag] [kl.] HH:mm:ss',
                    nextDay: 'DD/MM [kl.] HH:mm:ss',
                    nextWeek: 'DD/MM [kl.] HH:mm:ss',
                    lastDay: '[I går] [kl.] HH:mm:ss',
                    lastWeek: 'DD/MM [kl.] HH:mm:ss',
                    sameElse: 'DD/MM [kl.] HH:mm:ss'
                }) */
                return formatted
            }
            return null
        }
    },
    methods: {
        goToRoute (item) {
            if (this.$auth.user().userrole_id === 1) {
                this.$router.push({name: item.route})
            } else {
                this.$router.push({name: 'ComingSoon'})
            }
        },
        subIsActive (input) {
            const paths = Array.isArray(input) ? input : [input]
            return paths.some(path => {
            return this.$route.path.indexOf(path) === 0 // current path starts with this path string
            })
        },
        logout () {
            this.$auth.logout({
                makeRequest: true
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// Sidebar.vue?36b33501